(ns app.domain.appeals.model
  (:require [app.domain.group.model :as group-model]
            [app.i18n.model :as i18n-model]
            [core.db.child-entity :as child]))

(def ^{:arglists '([application])} application-appeals
  (child/child-entities-of-type-fn :entity.type/appeals-information))

(defmethod i18n-model/get-localized-string-attrs :entity.type/appeals-tribunal [_]
  [:appeals-tribunal/names :appeals-tribunal/descriptions])

(def appeals-tribunal-name (i18n-model/translation-fallback-fn :appeals-tribunal/names :appeals-tribunal/name))
(def appeals-tribunal-description (i18n-model/translation-fallback-fn :appeals-tribunal/descriptions :appeals-tribunal/description))

(defmethod group-model/get-authority-group :entity.type/appeals-tribunal [tribunal]
  (:entity/parent tribunal))

(defn enabled-for?
  "Return `true`, if the appeals feature is enabled for the permit type"
  [permit-type]
  (-> #{:permit-type/P
        :permit-type/LU}
      permit-type
      boolean))
